<template>
  <div>
    <div class="modal fade show custom-modal" id="underwriter" role="dialog" :class="{'modal-show':showModal}">
      <div class="modal-dialog modal-lg">
        <div class="modal-content ipad-portrait">
          <!-- Modal Header -->
          <div class="modal-header mr-3">
            <h4 class="modal-title ml-4 pl-2">Remarks for Underwriter</h4>
            <button type="button" class="close" aria-label="Close" @click="hideUnderwriterModal()" data-dismiss="modal" id="underwriter-cross-close">&times;</button>
          </div>
          <!-- Modal body -->
          <div class="modal-body pb-0">
            <div class="row pl-1">
              <div class="col-12">
                <p><strong> WorkFlowReasons: </strong></p><p v-for="(Reason, index) in workflowReason" :key="index">{{Reason}}</p>
              </div>
            </div>
            <div class="form-group">
              <float-label>
               <textarea type="text" rows="4" cols="30" class="form-control"  placeholder="User Remarks"
               v-model="generateQuoteData.userRemark">
              </textarea>
              </float-label>
            </div>
            <div class="row mt-3" v-show="stage!==2">
              <div class="col-lg-12 col-md-12 col-sm-12 pl-0">
                <input type="checkbox" class="bgc-checkbox" id="check1" v-model="generateQuoteData.additionalDocUpload" :disabled="generateQuoteData.policyDetails.planCode.value == '1812' && (generateQuoteData.policyDetails.vehicleType.value == '29' || generateQuoteData.policyDetails.vehicleType.value == '41')"/>
                <label class="checkbox-inline form-check-label pl-1" for="check1">
                  <span class="check ml-2"><strong> Upload documents for this Quote.</strong></span>
                </label>
              </div>
            </div>
            <div class="row mt-3 p-4" v-if="stage==1 && showNcbMsg">
              <p class="card p-4 shadow">
                You are not eligible for NCB since your policy is expired more than 90 days.
                Do you still want to continue with NCB.
                Please click OK to proceed with NCB or click cancel to proceed with "0" NCB.
              </p>
            </div>
          </div>
          <!-- Modal footer -->
          <div class="modal-footer border-0 float-right">
            <div v-if="stage==2 || !showNcbMsg">
              <button type="button" class="btn bgc-btn-primary button-add" data-dismiss="modal" @click="closeUnderwriterModal()" id="underwriter-save">Save</button>
            </div>
            <div v-else>
              <button type="button" class="btn bgc-btn-primary mx-4" data-dismiss="modal" @click="closeUnderwriterModal('okay')" id="underwriter-save">OK</button>
              <button type="button" class="btn bgc-btn-secondary " data-dismiss="modal" @click="closeUnderwriterModal('cancel')" id="underwriter-save">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import FloatLabel from "@/../shared_component/FloatLabel.vue";
import { computed, reactive } from '@vue/composition-api';
export default {
  name: "UnderwriterModal",
  props: ["showModal","workflowReason","generateQuoteData","stage"],
  components: {
    FloatLabel
  },
  setup(props,context){
    let state=reactive({
      userRemark:""
    });
    const showNcbMsg=computed(()=>{
      let flag = false;
      let tempArray = [];
      if(props.workflowReason && Array.isArray(props.workflowReason) && props.workflowReason.length>0)
      props.workflowReason.map(obj=>{
        tempArray.push(obj.split(":")[0]);
      })
      if(tempArray.includes('R0089')){
        flag = true;
      }
      else flag = false;
      return flag;
    })
    function closeUnderwriterModal(source){
      context.parent.closeUnderwriterModal(source);
      if(source!='cancel' && source!='okay')
        context.parent.issueQuote(props.generateQuoteData.userRemark);
    }
    function hideUnderwriterModal(){
      context.parent.hideUnderwriterModal();
    }
    return{
      state,
      closeUnderwriterModal,
      hideUnderwriterModal,
      showNcbMsg
    }
  }
}
</script>

<style scoped>
.custom-modal {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  transform: scale(0);
}
.modal-show {
  display: block;
  transform: scaleY(0) scaleX(0);
  animation: unfoldIn 0.25s cubic-bezier(0.165, 0.84, 0.44, 1) forwards;
}
input[type="text"] {
  max-width: 708px;
  min-height: 187px;
}
.button-add {
  width: 130px;
}
.bgc-btn-primary {
  margin-right: 12px;
}
@media (min-width: 992px) {
  .bgc-btn-primary {
    margin-right: 43px;
  }
}
</style>
